const AKSIONER_COLUMNS = [
  {
    field: "name",
    headerName: "Emer",
    width: 250,
    flex: 1,
    editable: false,
  },
  {
    field: "percentage",
    headerName: "Perqindje",
    width: 250,
    flex: 1,
    editable: false,
  },
];

export default AKSIONER_COLUMNS;
